import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import toastr from '../../toastr';
import Lunch from './modes/employees/Lunch';
import OffWork from './modes/employees/OffWork';
import PaidBreak from './modes/employees/PaidBreak';
import SickTime from './modes/employees/SickTime';
import StartWork from './modes/employees/StartWork';
import VacationTime from './modes/employees/VacationTime';
import ViewTime from './modes/employees/ViewTime';
import ViewTimeExtended from './modes/employees/ViewTimeExtended';

/* Each implemented mode should:
  1. provide its own .process() and validation logic which should
     return a promise.  resolve indicates the process was successful.
     reject means the request to process was unsuccessful, either due
     to form invalidation, or D3/QM error responses.
  2. focus to its first input on mount for fast UX

   - most modes share logic (including process logic) which can be
     found in ModeComponent, a base class all modes extend.
*/

export default class EmployeesModeConductor extends Component {
  static propTypes = {
    mode: PropTypes.string.isRequired,
    reset: PropTypes.func,
    userActive: PropTypes.string.isRequired,
    password: PropTypes.string,
  };

  onProcess = () => {
    this.activeModeRef
      .process(this.props.userActive, this.props.password)
      .then(successMsg => {
        toastr.success('Action processed.', successMsg);
        this.props.reset();
      })
      .catch(errorMsg => {
        if (!!errorMsg) {
          toastr.error('Error!', errorMsg);
        }
      });
  };

  setActiveModeRef = ref => {
    this.activeModeRef = ref;
  };

  render() {
    let modeRender;

    switch (this.props.mode) {
      case 'BK':
        modeRender = <PaidBreak ref={this.setActiveModeRef} />;
        break;
      case 'LU':
        modeRender = <Lunch ref={this.setActiveModeRef} />;
        break;
      case 'OW':
        modeRender = <OffWork ref={this.setActiveModeRef} />;
        break;
      case 'SI':
        modeRender = <SickTime ref={this.setActiveModeRef} />;
        break;
      case 'SW':
        modeRender = <StartWork ref={this.setActiveModeRef} />;
        break;
      case 'VA':
        modeRender = <VacationTime ref={this.setActiveModeRef} />;
        break;
      case 'VT':
        modeRender = <ViewTime ref={this.setActiveModeRef} />;
        break;
      case 'VB':
        modeRender = <ViewTimeExtended ref={this.setActiveModeRef} />;
        break;
      default:
        // Mode not implemented case
        return (
          <div className="tc-mode-conductor">
            <div style={{ fontSize: '2.5em', marginTop: '100px', textAlign: 'center' }}>
              Mode: {this.props.mode} not implemented.
            </div>
          </div>
        );
    }

    return (
      <div className="tc-mode-conductor">
        {modeRender}
        <Button variant="success" className="float-right" onClick={this.onProcess} id="processButton">
          Process
        </Button>
      </div>
    );
  }
}
